/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetReminderAttemptsByOrderAdminResponse } from '../models/GetReminderAttemptsByOrderAdminResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RemindersService {
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns GetReminderAttemptsByOrderAdminResponse OK
     * @throws ApiError
     */
    public static getReminderAttemptsByOrderIdAdmin({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<GetReminderAttemptsByOrderAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/reminders/orders/{orderId}/attempts',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
